import { default as general } from './general';
import { default as landing } from './landing';
import { default as navigation } from './navigation';
import { default as posts } from './posts';
import { default as tokenInfo } from './token-info';
import { default as watchlist } from './watchlist';
import { default as meta } from './meta';

export default {
  ...general,
  ...landing,
  ...posts,
  ...navigation,
  ...tokenInfo,
  ...watchlist,
  ...meta,
};
